import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

export const getTipMolzeList = createAsyncThunk(
  "tipMolze/getAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get("/api/sif/tipMolze");
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getTipMolzeBySifra = createAsyncThunk(
  "tipMolze/getBySifra",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`/api/sif/tipMolze/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const saveTipMolze = createAsyncThunk(
  "tipMolze/save",
  async (dto, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.post("/api/sif/tipMolze", dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateTipMolze = createAsyncThunk(
  "tipMolze/update",
  async ({ sifra, dto }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.put(`/api/sif/tipMolze/${sifra}`, dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deleteTipMolze = createAsyncThunk(
  "tipMolze/delete",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.delete(`/api/sif/tipMolze/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getTipMolzePage = createAsyncThunk(
  "tipMolze/getPage",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        "/api/sif/tipMolze/page",
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
const tipMolzeSlice = createSlice({
  name: "tipMolze",
  initialState: {
    list: [],
    current: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get all
      .addCase(getTipMolzeList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getTipMolzeList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getTipMolzeList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Get by sifra
      .addCase(getTipMolzeBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(getTipMolzeBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getTipMolzeBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Save
      .addCase(saveTipMolze.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(saveTipMolze.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(saveTipMolze.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Update
      .addCase(updateTipMolze.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(updateTipMolze.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateTipMolze.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Delete
      .addCase(deleteTipMolze.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(deleteTipMolze.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteTipMolze.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Get page
      .addCase(getTipMolzePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getTipMolzePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getTipMolzePage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default tipMolzeSlice.reducer;
